import React, { memo, useMemo } from 'react';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { StoryblokNode } from '../../interfaces/StoryblokNode.interface';
import { StoryblokArticleAuthor } from '../../interfaces/StoryblokArticleAuthor.interface';
import StructuredData from '../StructuredData/StructuredData';

interface ArticleStructuredDataProps {
  name: string;
  image: StoryblokAsset;
  datePublished: string;
  authors: StoryblokNode<StoryblokArticleAuthor>[];
  dateModified: string;
  slug: string;
}

const ArticleStructuredData: React.FC<ArticleStructuredDataProps> = ({
  name,
  image,
  datePublished,
  authors = [],
  dateModified,
  slug,
}) => {
  const articleStructuredData = useMemo(() => {
    const authorsStructuredData =
      authors.map((author: StoryblokNode<StoryblokArticleAuthor>) => {
        return {
          '@type': 'Person',
          name: author.content.full_name,
          url: author.content.linkedin_url,
        };
      }) || undefined;

    return {
      '@type': 'Article',
      name: name,
      image: image?.filename,
      datePublished: datePublished,
      author: authorsStructuredData,
      dateModified: dateModified,
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': `<${process.env.GATSBY_WEBSITE_URL}/${slug}>`,
      },
    };
  }, [name, image, datePublished, authors, dateModified, slug]);

  return <StructuredData>{articleStructuredData}</StructuredData>;
};

export default memo(ArticleStructuredData);
